import React from "react";
import TitleBox from "@/components/TitleBox";
import { GetPlantStatsResponse } from "@shared_types";
import one from "../../assets/tree1.png";
import two from "../../assets/tree2.png";
import three from "../../assets/tree3.png";
import four from "../../assets/tree4.png";
import five from "../../assets/tree5.png";
import six from "../../assets/tree6.png";
interface TreeGrowingProps {
  plantStats: GetPlantStatsResponse;
}
const TreeGrowing: React.FC<TreeGrowingProps> = ({ plantStats }) => {
  const plantSizePercentage =
    plantStats.waterDropletsCount / plantStats.waterDropletsNeeded;
  let plant;
  if (plantSizePercentage >= 0.833) {
    plant = six;
  } else if (plantSizePercentage >= 0.666) {
    plant = five;
  } else if (plantSizePercentage >= 0.5) {
    plant = four;
  } else if (plantSizePercentage >= 0.333) {
    plant = three;
  } else if (plantSizePercentage >= 0.166) {
    plant = two;
  } else {
    plant = one;
  }
  return (
    <div className="flex flex-col items-center justify-start w-full h-full gap-6 pt-6 pb-2">
      <div className="flex w-full items-center justify-center">
        <TitleBox
          title={`Your tree is growing! 🌳`}
          subtitle={
            <p>
              Keep going to earn enough water droplets to{" "}
              <span className="font-bold text-[var(--color-green)]">
                plant a tree!
              </span>
            </p>
          }
          classname="text-center items-center justify-center"
        />
      </div>
      <div className="flex flex-grow items-center justify-center w-full pb-4 pt-10 rounded-3xl bg-white">
        <img
          src={plant}
          alt="Tree"
          className="max-h-56 w-auto lg:max-h-72 lg:w-auto mt-2"
        />
      </div>
    </div>
  );
};
export default TreeGrowing;
